import script from "./CartGiftCardItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartGiftCardItem.vue?vue&type=script&setup=true&lang=ts"

import "./CartGiftCardItem.vue?vue&type=style&index=0&id=64058f2a&lang=css"

const __exports__ = script;

export default __exports__